import axios from "axios";

export const API = axios.create({
 baseURL: "https://a2zforex-api.skyapi.store/",
//baseURL: "http://localhost:8703/",
});
